module.exports = __webpack_public_path__ + "img/00011.08ef9d81.webp";